import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
import _imports_0 from '@/assets/img/notice1.png';
const _hoisted_1 = {
  key: 0,
  class: "contianer"
};
const _hoisted_2 = {
  class: "aside"
};
const _hoisted_3 = {
  class: "aside-inner"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "content"
};
const _hoisted_7 = {
  class: "content-header"
};
const _hoisted_8 = {
  class: "content-title"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_view = _resolveComponent("router-view");
  const _component_RegisterDialog = _resolveComponent("RegisterDialog");
  return $data.show ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.menubar, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      onClick: $event => $options.hanldeMenuClick(item),
      key: item.path,
      class: _normalizeClass({
        'menu-item': true,
        'menu-item-active': item.id === $data.current.id,
        'menu-item-first': index === 0,
        'menu-item-last': index === $data.menubar.length - 1,
        'menu-item-hidden': !item.show,
        'menu-item-leader': item.isLeader,
        'menu-item-apply': item.isApply
      })
    }, [item.icon ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      src: item.icon,
      alt: "",
      class: _normalizeClass({
        'menu-item-icon': true,
        'menu-item-icon-active': item.id === $data.current.id
      })
    }, null, 10, _hoisted_5)) : _createCommentVNode("", true), _createElementVNode("div", null, _toDisplayString(item.title), 1)], 10, _hoisted_4);
  }), 128))])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_cache[2] || (_cache[2] = _createElementVNode("div", {
    class: "content-title-tag"
  }, null, -1)), _createElementVNode("div", null, _toDisplayString($data.current.title || ""), 1), $data.current.title === '网评材料上传' ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "notice-box",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.handleNoticeClick && $options.handleNoticeClick(...args))
  }, _cache[1] || (_cache[1] = [_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }, null, -1), _createTextVNode(" 关于举办第三届中国医学教育题库命题创新大赛的通知（第一轮） ")]))) : _createCommentVNode("", true)])]), _createVNode(_component_router_view, {
    ref: "activity",
    onRefresh: $options.refresh,
    onUpdateUserInfo: $options.updateUserInfo,
    userSubmitFlag: $data.userSubmitFlag
  }, null, 8, ["onRefresh", "onUpdateUserInfo", "userSubmitFlag"]), _createVNode(_component_RegisterDialog, {
    ref: "registerDialog",
    onUpdateUserInfo: $options.updateUserInfo
  }, null, 8, ["onUpdateUserInfo"])])])) : _createCommentVNode("", true);
}